import CreditCardOffOutlinedIcon from "@mui/icons-material/CreditCardOffOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Box, Button, Chip, Divider, Typography } from "@mui/material";

import CasaLogo from "../../logo/CasaLogo";
import { logout } from "../../../keycloak";
import { InvoicePaymentStatus } from "../../../interfaces/User";
import styles from "./PaymentRestriction.module.scss";

interface PaymentRestrictionProps {
  invoicePaymentStatus?: InvoicePaymentStatus | null;
}

const PaymentRestriction = ({ invoicePaymentStatus }: PaymentRestrictionProps) => {
  const subtitle =
    invoicePaymentStatus?.state === "overdue" && invoicePaymentStatus.dueDate
      ? `Your invoice was due on ${invoicePaymentStatus.dueDate} and is now ${invoicePaymentStatus.daysOverdue} day(s) overdue. Please complete payment to restore access — contact us below if you've already paid.`
      : "Your account has one or more overdue invoices. Please clear your outstanding dues to regain full access to the dashboard.";

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <CasaLogo />
      </Box>

      <Box className={styles.body}>
        <Box className={styles.card}>
          <Box className={styles.iconWrapper}>
            <CreditCardOffOutlinedIcon className={styles.icon} />
          </Box>

          <Chip
            label="Payment Required"
            size="small"
            className={styles.chip}
            sx={{
              bgcolor: "error.light",
              color: "error.dark",
              fontWeight: 400,
            }}
          />

          <Typography variant="h5" className={styles.title}>
            Account Access Restricted
          </Typography>

          <Typography variant="body2" className={styles.subtitle}>
            {subtitle}
          </Typography>

          <Divider className={styles.divider} />

          <Box className={styles.supportBox}>
            <MailOutlineIcon
              fontSize="small"
              sx={{ color: "text.secondary" }}
            />
            <Box>
              <Typography variant="body2" color="text.secondary">
                Need help? Reach out to our support team
              </Typography>
              <Typography variant="body2" fontWeight={600} color="text.primary">
                care@casaretail.ai
              </Typography>
            </Box>
          </Box>

          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<LogoutOutlinedIcon />}
            onClick={logout}
            className={styles.logoutButton}
          >
            Sign out
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentRestriction;
